import type { ExternalContactView } from "../shared/types";

export interface ExternalContactCopyDiagnostic {
  currentFollowRelation: {
    matched: boolean;
    matchedUserId: string | null;
    hasRemark: boolean;
    hasRemarkCorpName: boolean;
    mobileCount: number;
    hasDescription: boolean;
  };
}

export function buildExternalContactDiagnosticForCopy(
  externalContact: ExternalContactView | null
): ExternalContactCopyDiagnostic {
  const relation = externalContact?.currentFollowRelation ?? null;

  return {
    currentFollowRelation: {
      matched: Boolean(relation),
      matchedUserId: relation?.userId ?? null,
      hasRemark: Boolean(relation?.remark),
      hasRemarkCorpName: Boolean(relation?.remarkCorpName),
      mobileCount: relation?.remarkMobiles.length ?? 0,
      hasDescription: Boolean(relation?.description)
    }
  };
}

export function formatCustomerType(type: number | null | undefined): string {
  if (type === 1) {
    return "微信客户";
  }

  if (type === 2) {
    return "企业微信客户";
  }

  return type == null ? "未返回" : `未知类型 ${type}`;
}
